import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["currentPage", "totalPages", "onPrev", "onNext", "isDark", "dark", "isWhite", "white", "className", "htmlProps"];
import { forwardRef } from 'react';
import cn from 'classnames';
import IconButton from "../../Buttons/IconButton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Carousel = function Carousel(_ref, ref) {
  var _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
    _ref$totalPages = _ref.totalPages,
    totalPages = _ref$totalPages === void 0 ? 1 : _ref$totalPages,
    onPrev = _ref.onPrev,
    onNext = _ref.onNext,
    isDark = _ref.isDark,
    dark = _ref.dark,
    isWhite = _ref.isWhite,
    white = _ref.white,
    className = _ref.className,
    htmlProps = _ref.htmlProps,
    carouselPaginationProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: cn('flex items-center', className)
  }, carouselPaginationProps), htmlProps), {}, {
    children: [/*#__PURE__*/_jsxs("p", {
      className: "mr-40 tw-font-pop text-16 leading-20 tracking-4 flex items-center justify-center flex-shrink-0 text-center ".concat(isDark || dark ? 'text-white' : 'text-base-main'),
      children: [/*#__PURE__*/_jsx("span", {
        className: "tw-font-semibold mr-4",
        children: "".concat(currentPage.toString().length < 2 ? 0 : '').concat(currentPage)
      }), "/ ".concat(totalPages.toString().length < 2 ? 0 : '').concat(totalPages)]
    }), /*#__PURE__*/_jsx(IconButton, {
      className: "flex-shrink-0 mr-16",
      arrow: "left",
      isDark: isDark || dark,
      isWhite: isWhite || white,
      disabled: currentPage <= 1,
      onClick: onPrev
    }), /*#__PURE__*/_jsx(IconButton, {
      className: "flex-shrink-0",
      arrow: "right",
      isDark: isDark || dark,
      isWhite: isWhite || white,
      disabled: currentPage >= totalPages,
      onClick: onNext
    })]
  }));
};
export default /*#__PURE__*/forwardRef(Carousel);